import * as BECaller from '../../util/apiCaller';
import { setError, setSuccessMessage } from '../App/ErrorsActions';
import { getInfo } from '../Auth/AuthActions';

export const INVOICES = 'BILLING_INVOICES',
  SUCCESS_SETTING = 'BILLING_SETTING_SUCCESS',
  CUSTOMER = 'BILLING_CUSTOMER',
  USERS = 'BILLING_USERS',
  UPDATE_CUSTOMER = 'BILLING_UPDATE_CUSTOMER',
  UPDATING_BILLING = 'BILLING_UPDATING_BILLING',
  REACTIVATING = 'BILLING_REACTIVATING',
  UPDATING_COUPON = 'BILLIN_UPDATING_COUPON';

export function error(err) {
  return setError(err);
}

export function getInvoices(offset) {
  return (dispatch, getState) => {
    BECaller.api(`billing/invoices?offset=${offset || ''}`, 'get').then(
      (data) => {
        let invoices = offset ? getState().billing.invoices : {};
        let list = [];
        if (invoices.list) {
          list = invoices.list.concat(data.list);
        } else {
          list = data.list;
        }

        dispatch({
          type: INVOICES,
          data: {
            list,
            next_offset: data.next_offset,
          },
        });
      },
      (err) => {
        dispatch(setError(err));
      }
    );
  };
}

export function successSetting(data) {
  return {
    type: SUCCESS_SETTING,
    settings: data,
  };
}

export function getSettings() {
  return (dispatch) => {
    BECaller.api(`billing/settings`, 'get').then(
      (data) => {
        dispatch(successSetting(data));
      },
      (err) => {
        dispatch(setError(err));
      }
    );
  };
}

export function getCustomerBilling() {
  return (dispatch) => {
    return BECaller.api(`billing/customer`, 'get').then(
      (data) => {
        dispatch({
          type: CUSTOMER,
          data,
        });

        return Promise.resolve(data);
      },
      (err) => {
        dispatch(setError(err));

        return Promise.reject(err);
      }
    );
  };
}

export function getUsers() {
  return (dispatch) => {
    BECaller.api(`billing/users`, 'get').then(
      (data) => {
        dispatch({
          type: USERS,
          data,
        });
      },
      (err) => {
        dispatch(setError(err));
      }
    );
  };
}

export function downloadInvoice(id) {
  return (dispatch) => {
    BECaller.api(`/billing/invoices/${id}/download`, 'get').then(
      (data) => {
        window.open(data.url, '_blank');
      },
      (err) => {
        dispatch(setError(err));
      }
    );
  };
}

export function saveBillingInfo(model) {
  return (dispatch) => {
    dispatch({
      type: UPDATING_BILLING,
      value: true,
    });
    BECaller.api(`/billing/customer`, 'put', model).then(
      (data) => {
        dispatch({
          type: UPDATE_CUSTOMER,
          data: data,
        });
        dispatch(setSuccessMessage('Billing information updated successfully'));
      },
      (err) => {
        dispatch({
          type: UPDATING_BILLING,
          value: false,
        });
        dispatch(setError(err));
      }
    );
  };
}

export function savePaymentInfo(data) {
  return (dispatch) => {
    BECaller.api(`/billing/customer/payment`, 'put', data).then(
      (data) => {
        dispatch({
          type: UPDATE_CUSTOMER,
          data: data,
        });
        dispatch(setSuccessMessage('Payment method updated successfully'));
      },
      (err) => {
        dispatch(setError(err));
      }
    );
  };
}

export function toggleAutorenewal() {
  return (dispatch) => {
    BECaller.api(`/billing/autorenewal`, 'put').then(
      (data) => {
        dispatch({
          type: UPDATE_CUSTOMER,
          data: data,
        });
        if (data.subscription.status == 'non_renewing') {
          dispatch(setSuccessMessage('You turned off Auto-Renewal successfully'));
        } else {
          dispatch(setSuccessMessage('You turned on Auto-Renewal successfully'));
        }
      },
      (err) => {
        dispatch(setError(err));
      }
    );
  };
}

export function reactivateSubscription() {
  return (dispatch) => {
    dispatch({
      type: REACTIVATING,
    });
    BECaller.api(`/billing/reactivate`, 'put').then(
      (data) => {
        dispatch({
          type: UPDATE_CUSTOMER,
          data: data,
        });
        dispatch(getInfo());
        dispatch(setSuccessMessage('Your subscription has been activated successfully'));
      },
      (err) => {
        if (err.data && err.data.payment) {
          return dispatch(setError(err.data.payment.error.message));
        }
        dispatch(setError(err));
      }
    );
  };
}

export function applyCoupon(coupon) {
  return (dispatch) => {
    dispatch({
      type: UPDATING_COUPON,
      value: true,
    });

    return BECaller.api(`/billing/coupon`, 'put', { coupon }).then(
      (data) => {
        dispatch({
          type: CUSTOMER,
          data,
        });
        dispatch(setSuccessMessage('Coupon applied successfully'));

        return Promise.resolve();
      },
      (err) => {
        dispatch({
          type: UPDATING_COUPON,
          value: false,
        });
        dispatch(setError(err));

        return Promise.reject();
      }
    );
  };
}

export function removeCoupon() {
  return (dispatch) => {
    return BECaller.api(`/billing/coupon`, 'delete').then(
      (data) => {
        dispatch({
          type: CUSTOMER,
          data,
        });
        dispatch(setSuccessMessage('Coupon removed successfully'));
        return Promise.resolve();
      },
      (err) => {
        dispatch(setError(err));
        return Promise.reject();
      }
    );
  };
}
